export default "__VITE_ASSET__up4m105r__"